var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-tab-ul"},_vm._l((_vm.tabList),function(item){return _c('div',{key:item.value,staticClass:"g-tab-li",class:{ active: item.value == _vm.selected },on:{"click":function($event){_vm.selected = item.value}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }